import { render, staticRenderFns } from "./FieldLink.vue?vue&type=template&id=7238914e&scoped=true&"
import script from "./FieldLink.vue?vue&type=script&lang=js&"
export * from "./FieldLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238914e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7238914e')) {
      api.createRecord('7238914e', component.options)
    } else {
      api.reload('7238914e', component.options)
    }
    module.hot.accept("./FieldLink.vue?vue&type=template&id=7238914e&scoped=true&", function () {
      api.rerender('7238914e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldLink.vue"
export default component.exports